import { render, staticRenderFns } from "./BillingBreakdown.vue?vue&type=template&id=7b573c16&"
import script from "./BillingBreakdown.vue?vue&type=script&lang=js&"
export * from "./BillingBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports